const or32 = (a, b) => a | b;
export default or32;
